import { useEffect, useState } from 'react';
export function useWindowResize() {
  const _useState = useState({
      width: window.innerWidth,
      height: window.innerHeight
    }),
    container = _useState[0],
    setContainer = _useState[1];
  useEffect(() => {
    const onWindowResize = () => {
      setContainer({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };
    window.addEventListener('resize', onWindowResize);
    return () => {
      window.removeEventListener('resize', onWindowResize);
    };
  });
  return [container];
}
//# sourceMappingURL=useWindowResize.js.map